import { render, staticRenderFns } from "./registerManager.vue?vue&type=template&id=f2153be8"
import script from "./registerManager.vue?vue&type=script&lang=js"
export * from "./registerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports